import { createSlice } from '@reduxjs/toolkit';

const initialState = {
 tabValue: 0,
 Line: {},
 selectedDefect: '',
}

export const trendSlice = createSlice({
  name: 'trend',
  initialState,
  reducers: {
    UpdateTrend: (state, action) => {
      let data = action.payload;
      state.tabValue = data.tabValue;
      state.Line = data.Line;
      state.selectedDefect = data.selectedDefect;
    },
  },
})

// Action creators are generated for each case reducer function
export const { UpdateTrend } = trendSlice.actions;

export default trendSlice.reducer